var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class LG {
    constructor(socket, log) {
        this.socket = socket;
        this.deviceId = '01';
        this.displayBlank = false;
        this.displayFreeze = false;
        this.input = '90'; // hdmi 1
        this.power = false;
        this.firmwareVersion = '314159';
        this.serialNumber = '907MXEZPR188';
        this.signalActive = true;
        this.speakerVolume = 50;
        this.temperature = 27; // Degrees C
        this.timeElapsed = 0;
        this.volumeMute = false;
        // Validate all video inputs so that the emulator supports all models and we don't have to keep
        // updating this code every time we add a new model to equipmentTypes.json. Define a few
        // invalid video inputs for testing the emulator's response to invalid video input codes.
        this.invalidVideoInputs = ['xx', 'yy', 'zz'];
        this.asyncHandlers = [
            {
                name: 'activeSignalGet',
                regExp: /sv\s+([0-9a-f]+)\s+([0-9a-f]{2})\s+FF/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`v ${this.deviceId} OK${match[2]}${this.signalActive ? '01' : '00'}`);
                    }
                    // nothing is returned if powered off
                },
            },
            {
                name: 'displayBlank',
                regExp: /kd\s+([0-9a-f]+)\s+([0-9a-f]+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[2] !== 'FF')
                            this.displayBlank = match[2] === '01';
                        this.socket.send(`d ${this.deviceId} OK${this.displayBlank ? '01' : '00'}`);
                    }
                    else {
                        this.socket.send(`d ${this.deviceId} NG00`);
                    }
                },
            },
            {
                name: 'displayFreeze',
                regExp: /kx\s+([0-9a-f]+)\s+([0-9a-f]{2})/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[2] !== 'FF')
                            this.displayFreeze = match[2] === '00';
                        this.socket.send(`x ${this.deviceId} OK${this.displayFreeze ? '00' : '01'}`);
                    }
                    else {
                        this.socket.send(`x ${this.deviceId} NG00`);
                    }
                },
            },
            {
                name: 'firmwareVersionGet',
                regExp: /fz\s+([0-9a-f]+)\s+FF/i,
                callback: (match) => {
                    if (this.power)
                        this.socket.send(`z ${this.deviceId} OK${this.firmwareVersion}`);
                    // nothing is returned if powered off
                },
            },
            {
                name: 'input',
                regExp: /xb\s+([0-9a-f]+)\s+([0-9a-f]+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[2] !== 'FF')
                            this.input = match[2];
                        const result = this.invalidVideoInputs.includes(this.input) ? 'NG' : 'OK';
                        this.socket.send(`b ${this.deviceId} ${result}${this.padLeft(this.input, 2)}`);
                    }
                    // nothing is returned if powered off
                },
            },
            {
                name: 'power',
                regExp: /ka\s+([0-9a-f]+)\s+([0-9a-f]+)/i,
                callback: (match) => {
                    if (match[2] !== 'FF')
                        this.power = match[2] === '01';
                    this.socket.send(`a ${this.deviceId} OK${this.power ? '01' : '00'}`);
                    if (this.power)
                        this.timeElapsed = 0;
                    if (match[2] !== 'FF' && this.socket.getPort() === 9761) {
                        this.socket.setCanConnect(this.power);
                    }
                },
            },
            {
                name: 'serialNumberGet',
                regExp: /fy\s+([0-9a-f]+)\s+FF/i,
                callback: (match) => {
                    if (this.power)
                        this.socket.send(`y ${this.deviceId} OK${this.serialNumber}`);
                    // nothing is returned if powered off
                },
            },
            {
                name: 'temperatureGet',
                regExp: /dn\s+([0-9a-f]+)\s+FF/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`n ${this.deviceId} OK${this.temperature.toString(16)}`);
                    }
                    // nothing is returned if powered off
                },
            },
            {
                name: 'timeElapsedGet',
                regExp: /dl\s+([0-9a-f]+)\s+FF/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`l ${this.deviceId} OK${this.timeElapsed.toString(16)}`);
                        this.timeElapsed++;
                    }
                    // nothing is returned if powered off
                },
            },
            {
                name: 'volume',
                regExp: /kf\s+([0-9a-f]+)\s+([0-9a-f]+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[2] !== 'FF') {
                            const speakerVolume = parseInt(match[2], 16);
                            if (speakerVolume >= 0 && speakerVolume <= 100) {
                                this.speakerVolume = speakerVolume;
                            }
                        }
                        this.socket.send(`f ${this.deviceId} OK${this.padLeft(this.speakerVolume.toString(16), 2)}`);
                    }
                    else {
                        this.socket.send(`f ${this.deviceId} NG00`);
                    }
                },
            },
            {
                name: 'volumeMute',
                regExp: /ke\s+([0-9a-f]+)\s+([0-9a-f]+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[2] !== 'FF')
                            this.volumeMute = match[2] === '00';
                        this.socket.send(`e ${this.deviceId} OK${this.volumeMute ? '00' : '01'}`);
                    }
                    else {
                        this.socket.send(`e ${this.deviceId} NG00`);
                    }
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['\r'],
        };
        this.sendTerminator = 'x';
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 9761 || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 9761 || this.power);
        });
    }
    onConfigure(config) {
        var _a, _b;
        this.deviceId = (_a = config === null || config === void 0 ? void 0 : config.lgDeviceId) !== null && _a !== void 0 ? _a : '01';
        let lowestCode;
        for (const videoInput of Object.values((_b = config.videoInputs) !== null && _b !== void 0 ? _b : {})) {
            if (this.input === videoInput.code)
                return;
            if (lowestCode === undefined || videoInput.code < lowestCode) {
                lowestCode = videoInput.code;
            }
        }
        this.input = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '90';
    }
    padLeft(value, length) {
        return Array(length - value.length + 1).join('0') + value;
    }
}
LG.emulatorType = 'socketEmulator';
LG.key = '-L6J1y52skPysi1v8USb';
